import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./auth.css";
import { useNavigate } from "react-router-dom";
import { registerUser, getAuthErrorMessage } from "../../utils/functionFirebase";
import { toast } from 'react-toastify';
const Register = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");

const navigate=useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password  || !phone || !name) {
      setError("يرجى تعبئة جميع الحقول.");
      return;
    }

    setError("");
    const result = await registerUser(email, password, phone, name);
    if (result.success) {
      toast.success("تم إنشاء الحساب بنجاح!");
      navigate("/")
      // يمكنك هنا إعادة التوجيه أو تحديث الحالة حسب الحاجة
    } else {
      const errorMsg = result.error && result.error.startsWith("auth/")
        ? getAuthErrorMessage(result.error)
        : (result.error || "فشل إنشاء الحساب. تأكد من صحة البيانات.");
      setError(errorMsg);
    }
  };

  return (
    <div >
    <div >
        <h2 className="mb-4 text-center">إنشاء حساب جديد</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="name" className="register-label">الاسم</label>
            <input
              type="text"
              className="register-input"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="أدخل اسمك الكامل"
              autoComplete="name"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="email" className="register-label">البريد الإلكتروني</label>
            <input
              type="email"
              className="register-input"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="أدخل بريدك الإلكتروني"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="register-label">كلمة المرور</label>
            <input
              type="password"
              className="register-input"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="أدخل كلمة المرور"
            />
          </div>
       
          <div className="mb-3">
            <label htmlFor="phone" className="register-label">رقم الهاتف</label>
            <input
              type="tel"
              className="register-input"
              id="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="أدخل رقم هاتفك"
            />
          </div>

          <button type="submit" className="register-btn">إنشاء الحساب</button>
        </form>
      </div>
    </div>
  );
};

export default Register;
